/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useCallback } from "react";
import { FaBars } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { ScrollTop } from "primereact/scrolltop";

import { Button } from "primereact/button";
import { Link, useHistory } from "react-router-dom";
import { LuGavel } from "react-icons/lu";

import { useTimer } from "../../hooks/timer";

const MOBILE_QUERY = "(max-width: 767.98px)";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Main = ({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
  props,
}) => {
  const history = useHistory();

  const token = localStorage.getItem("@Jurisnet:token");

  const { isActive, elapsedSeconds: timer, start, reset } = useTimer();

  const signOut = useCallback(() => {
    const doLogout = async () => {
      try {
        if (token) {
          await fetch(`${process.env.REACT_APP_API_URL}/audit/logout`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
      } catch {
        // não faz nada, logout não pode falhar para o usuário
      } finally {
        if (token) {
          localStorage.removeItem("@Jurisnet:token");
          localStorage.removeItem("@Jurisnet:user");
          localStorage.removeItem("@Jurisnet:lawsuit");
          localStorage.removeItem("@Jurisnet:judgingbody");
          localStorage.removeItem("@Jurisnet:counter");
          reset();
          sessionStorage.removeItem("@Jurisnet:access");
          localStorage.removeItem("@Jurisnet:access");

          history.push("/");
        }
      }
    };

    doLogout();
  }, [history, reset, token]);

  const handleStart = () => {
    start();
  };

  const handlePause = () => {
    handleWorkingHourRegistration();
  };

  const handleReset = () => {
    reset();
  };

  const formatTime = () => {
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = `${Math.floor(timer / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  const handleWorkingHourRegistration = () => {
    history.push({
      pathname: "/management/workinghour/create",
      state: {
        data: `${formatTime()}`,
      },
    });
    localStorage.setItem("@Jurisnet:counter", JSON.stringify(formatTime()));
    handleReset();
  };

  const openWorkingHourRegistration = () => {
    history.push({
      pathname: "/management/workinghour/create",
    });
    localStorage.setItem("@Jurisnet:counter", JSON.stringify("00:00"));
    handleReset();
  };

  const handleMenuButton = () => {
    if (window.matchMedia(MOBILE_QUERY).matches) {
      handleToggleSidebar(!toggled);
    } else {
      handleCollapsedChange(!collapsed);
    }
  };

  if (token) {
    return (
      <main>
        <header className={`app-header ${isActive ? "is-running" : ""}`}>
          <button
            type="button"
            className="header-menu-button"
            onClick={handleMenuButton}
            aria-label="Recolher ou abrir o menu"
            title="Recolher ou abrir o menu"
          >
            <FaBars />
          </button>

          <div className="header-timer">
            <span className="header-timer-dot" aria-hidden="true" />
            <span
              className="header-timer-clock"
              role="timer"
              aria-label="Tempo registrado"
            >
              {formatTime().replace(/ /g, "")}
            </span>
            {!isActive ? (
              <Button
                icon="pi pi-play"
                label="Iniciar"
                className="p-button-sm"
                onClick={handleStart}
              />
            ) : (
              <Button
                icon="pi pi-pause"
                label="Parar"
                className="p-button-sm p-button-danger"
                onClick={handlePause}
              />
            )}
            <Button
              icon="pi pi-times"
              className="p-button-sm p-button-rounded p-button-text p-button-secondary header-reset"
              onClick={handleReset}
              disabled={isActive}
              aria-label="Zerar"
              title="Zerar"
            />
            <span className="header-divider" aria-hidden="true" />
            <Button
              icon="pi pi-clock"
              label="Cadastrar Hora"
              className="p-button-sm p-button-text header-register"
              onClick={openWorkingHourRegistration}
              disabled={isActive}
            />
          </div>

          <Link
            to="/lawsuit/main/search"
            className="header-consult"
            title="Consultar processos"
          >
            <LuGavel />
            <span>Consultar processos</span>
          </Link>

          <button type="button" className="logout-button" onClick={signOut}>
            <FiLogOut />
            <span>Sair</span>
          </button>
        </header>

        <div style={{ maxWidth: "100%" }}>
          {props.children}
          <ScrollTop />
        </div>

        <footer>
          <small>
            © {new Date().getFullYear()} JN 2.0 · Desenvolvido por{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://oleiros.com.br/?utm_source=jurisnet&utm_medium=rodape&utm_campaign=sistema"
            >
              Oleiro Digital
            </a>
          </small>
        </footer>
      </main>
    );
  }
  return (
    <main>
      <div style={{ maxWidth: "100%" }}>{props.children}</div>
    </main>
  );
};

export default Main;
